import { all, put, takeEvery } from "redux-saga/effects";
import { fetcher, getErrorMsg, handleError } from "lib/fetch";
import * as actions from "./actions";

const url = "payment-channel"

function* loadPaymentChannels(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(url, params, token);
    yield put(actions.loadPaymentChannels.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.loadPaymentChannels.failure(getErrorMsg(error)));
  }
}

function* showPaymentChannel(action) {
  try {
    const { id, token } = action.payload;
    const res = yield fetcher.get(`${url}/${id}`, token);
    yield put(actions.showPaymentChannel.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.showPaymentChannel.failure(getErrorMsg(error)));
  }
}

function* createPaymentChannel(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/create`, params, token);
    yield put(actions.createPaymentChannel.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.createPaymentChannel.failure(getErrorMsg(error)));
  }
}

function* updatePaymentChannel(action) {
  try {
    const { params, id, token } = action.payload;
    const res = yield fetcher.post(`${url}/update/${id}`, params, token);
    yield put(actions.updatePaymentChannel.success(res.data));
   
  } catch (error) {
    handleError(error);
    yield put(actions.updatePaymentChannel.failure(getErrorMsg(error)));
  }
}

function* deletePaymentChannel(action) {
  try {
    const { id, token } = action.payload;
    yield fetcher.get(`${url}/delete/${id}`, token);
    yield put(actions.deletePaymentChannel.success(id));
  } catch (error) {
    handleError(error);
    yield put(actions.deletePaymentChannel.failure(getErrorMsg(error)));
  }
}


export default function* watchPaymentChannel() {
  yield all([
    takeEvery(actions.LOAD_PAYMENTCHANNEL.REQUEST, loadPaymentChannels),
    takeEvery(actions.SHOW_PAYMENTCHANNEL.REQUEST, showPaymentChannel),
    takeEvery(actions.CREATE_PAYMENTCHANNEL.REQUEST, createPaymentChannel),
    takeEvery(actions.UPDATE_PAYMENTCHANNEL.REQUEST, updatePaymentChannel),
    takeEvery(actions.DELETE_PAYMENTCHANNEL.REQUEST, deletePaymentChannel),
  ]);
}
